module.exports = __webpack_public_path__ + "static/media/12.40b9e103.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/12.wav
// module id = 40
// module chunks = 0